<div *ngIf="(projetsListLoading$ | async) || (projetsAuditListLoading$ | async)" class="spinner-placeholder">
    <app-loading-spinner></app-loading-spinner>
</div>

<ng-container *ngIf="((projetsList$ | async) || (projetsAuditList$ | async)) as projetsList">
    <app-projets-list [projetDataType]="projetDataType" [projets]="projetsList" class="fullSpace"></app-projets-list>
</ng-container>